import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateModal, { CreateModalProps } from "./index";
import { useToast } from "@packages/contexts/ToastContext";

interface ClassroomManagementCreateModalProps
  extends Omit<CreateModalProps, "onSubmit"> {
  onSubmit: (input: any) => Promise<void>;
}

export const ClassroomManagementCreateModal: React.FC<
  ClassroomManagementCreateModalProps
> = ({ onSubmit, initialInput, ...props }) => {
  const { t } = useTranslation();
  const { addToast } = useToast();

  const [problemDescription, setProblemDescription] = useState("");

  const handleSubmit = async (input: any) => {
    // Validate problem description
    if (!problemDescription?.trim()) {
      addToast({
        title: t("notifications.classroomManagement.emptyProblemDescription"),
        variant: "error",
        duration: 3000,
      });
      return;
    }

    // Prepare submission data with classroom management-specific fields
    const submissionData = {
      ...input,
      problemDescription,
    };

    await onSubmit(submissionData);
  };

  const ClassroomManagementSpecificFields = () => (
    <div className="space-y-6">
      {/* Problem Description */}
      <div className="space-y-2">
        <label className="inline-block text-sm font-medium text-fuchsia-700 dark:text-fuchsia-300">
          {t("classroomManagement.form.problemDescription")}
        </label>
        <textarea
          value={problemDescription}
          onChange={(e) => setProblemDescription(e.target.value)}
          className="w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent dark:bg-gray-700/50 transition-all duration-200"
          rows={4}
          placeholder={t(
            "classroomManagement.form.problemDescriptionPlaceholder",
          )}
        />
      </div>
    </div>
  );

  return (
    <CreateModal
      {...props}
      themeColor="fuchsia"
      onSubmit={handleSubmit}
      initialInput={initialInput}
      after={<ClassroomManagementSpecificFields />}
    />
  );
};

export default ClassroomManagementCreateModal;
